import React from "react";
import useOrgProfile, { orgContactLine } from "../../util/accounting/orgProfile";

/**
 * The organisation letterhead and watermark for pages printed straight from the
 * browser (Ctrl+P or a page's own Print button).
 *
 * Both are hidden on screen — the print stylesheet in styles/appShell.css
 * reveals them and strips the app chrome, so any page comes off the printer
 * with the organisation badge, name, contacts and TIN above the content and a
 * faint organisation mark on every sheet.
 *
 * The badge is always the organisation's own logo (or its initials when none is
 * configured); the Accountify crest never stands in for it.
 *
 * Rendered once by AppContainer, so every page gets it automatically.
 */
const PrintLetterhead = ({ title, subtitle }) => {
  const org = useOrgProfile();
  const contact = orgContactLine(org);
  const stamp = new Date().toLocaleString("en-GB", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });

  return (
    <>
      {/* position: fixed is what repeats this on every printed sheet. */}
      <div className="print-watermark" aria-hidden="true">
        {org.logo
          ? <img src={org.logo} alt="" />
          : <span className="print-watermark-text">{org.initials}</span>}
      </div>

      <div className="print-letterhead" aria-hidden="true">
        <div className="print-letterhead-main">
          <div className="print-brand">
            {org.logo
              ? <img className="print-badge" src={org.logo} alt="" />
              : <div className="print-badge print-badge-initials">{org.initials}</div>}
            <div>
              <div className="print-org-name">{org.name}</div>
              {contact && <div className="print-org-contact">{contact}</div>}
              {org.tin && <div className="print-org-contact">TIN: {org.tin}</div>}
            </div>
          </div>
        </div>
        <div className="print-doc-title-block">
          <div className="print-doc-title">{title || "Report"}</div>
          {subtitle && <div className="print-doc-subtitle">{subtitle}</div>}
          <div className="print-letterhead-meta">Generated {stamp} — Accountify</div>
        </div>
      </div>
    </>
  );
};

export default PrintLetterhead;
